import React from 'react';
import 'normalize.css/normalize.css';
import './css/index.scss';

import Headline1 from './comp/Headline1';
import Headline2 from './comp/Headline2';
import Headline3 from './comp/Headline3';

// Font Awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse,faArrowUpRightFromSquare,faLink } from "@fortawesome/free-solid-svg-icons";
import { faFileExcel,faFilePdf } from "@fortawesome/free-regular-svg-icons";

class App extends React.Component {
  render() {
    return (
        <section>
          <Headline1 content="大見出し h1" />
          <Headline2 content="中見出し h2" />
          <Headline3 content="小見出し h3" />
          <div><p>テスト</p></div>
          <FontAwesomeIcon icon={faHouse} className="faIcoms" />
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="faIcoms" />
          <FontAwesomeIcon icon={faLink} className="faIcoms" />
          <FontAwesomeIcon icon={faFilePdf} className="faIcoms" />
          <FontAwesomeIcon icon={faFileExcel} className="faIcoms" />
        </section>
    );
  }
}

export default App;
